import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgVirtualGames = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.83 3a2.17 2.17 0 0 0-1.867 1.062L2.237 10.25a.75.75 0 0 0-.237.547v7.116a2.173 2.173 0 0 0 2.173 2.173h4.273a2.17 2.17 0 0 0 1.693-.823l1.851-2.304h.02l1.851 2.304a2.17 2.17 0 0 0 1.693.823h4.273A2.173 2.173 0 0 0 22 17.912v-7.116a.75.75 0 0 0-.237-.546l-3.725-6.185v-.003A2.17 2.17 0 0 0 16.17 3zm12.06 7.046L16.748 4.83a.67.67 0 0 0-.578-.33H7.83a.67.67 0 0 0-.578.33l-.003.004-3.139 5.212h15.78m-16.39 1.5h17v6.366a.673.673 0 0 1-.673.673H15.56a.67.67 0 0 1-.524-.256l-.004-.005-1.864-2.319a1.47 1.47 0 0 0-1.197-.547 1.46 1.46 0 0 0-1.14.547l-1.863 2.32-.004.004a.67.67 0 0 1-.524.256H4.173a.673.673 0 0 1-.673-.673z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgVirtualGames;
